import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import BlueButton from '../Atoms/BlueButton';
import BigH3 from '../Atoms/BigH3';
import Input from '../Atoms/Input';
import Textarea from '../Atoms/Textarea';
import Select from '../Atoms/Select';
import { FD100MultiSelectOptions } from '../Utils/Listings';
import * as api from '../../api';
import BigH2 from '../Atoms/BigH2';
import { MediaUploadWithDropzone, MediaPreviewItem } from './MediaUploadWithDropzone';
import React, { useState, useEffect, useRef } from 'react';

import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { linkify } from '../Utils/Format';

// Import the item management components
// Create a separate file called ProjectItemManagement.js with the component code
import { 
  AwardItemComponent, 
  PressLinkItemComponent, 
  FabricantItemComponent 
} from './ProjectItemManagement';

// Styled components
const ProjectDetailContainer = styled.div`
  background-color: white;
  padding: 30px;
  border: 1px solid black;
  border-radius: 0px;
  margin-top: 20px;
`;
const BigH3WithMargin = styled(BigH3)`
  margin-bottom: 15px ;
  margin-top: 50px!important;
`;
const BackButton = styled(BlueButton)`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 40px;
  color: white;
  font-weight: bold;
  
  img {
    transform: rotate(180deg);
    margin-right: 10px;
  }
  
  &:hover {
  }
`;

const ProjectHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  h2 {
    margin: 0;
    font-size: 24px;
  }
`;

const ProjectGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ProjectSection = styled.div`
  margin-bottom: 20px;
`;

const DetailItem = styled.div`
  margin-bottom: 15px;
  
  
  & .label {
    font-weight: bold;
    color: rgb(0, 0, 255);
    margin-bottom: 5px;
    display: block;
  }
  
  & .value {
    color: #333;
  }
`;

const MediaGallery = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
`;

const EditModeContainer = styled.div`
  margin-top: 20px;
  
  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  
  .button-container {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
  
  .note {
    color: #666;
    font-size: 0.9em;
    font-style: italic;
    margin-top: 5px;
  }
  
  .error-note {
    color: red;
    font-size: 0.9em;
    font-style: italic;
    margin-top: 5px;
  }
`;

const SaveButton = styled.button`
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  
  &:hover {
    background-color: #45a049;
  }
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const CancelButton = styled.button`
  background-color: #f44336;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  
  &:hover {
    background-color: #d32f2f;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;
  
  span {
    flex-grow: 1;
    margin-right: 10px;
  }
`;

// const MiniatureContainer = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 20px;
//   margin-top: 20px;
// `;

// const SectionTitle = styled.div`
//   font-weight: bold;
//   color: rgb(0, 0, 255);
//   font-size: 18px;
//   margin-bottom: 15px;
//   margin-top: 20px;
// `;

// const LinkItem = styled.div`
//   margin-bottom: 10px;
//   display: flex;
//   gap: 10px;
//   align-items: center;

//   input {
//     flex-grow: 1;
//   }
// `;

// const AwardItem = styled.div`
//   margin-bottom: 10px;
//   display: flex;
//   gap: 10px;
//   align-items: center;

//   input {
//     flex-grow: 1;
//   }
// `;

// const FabricantItem = styled.div`
//   border: 1px solid #ddd;
//   border-radius: 4px;
//   padding: 15px;
//   margin-bottom: 15px;
// `;

const AddButton = styled.button`
  background-color: #0000FF;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 10px;
  
  &:hover {
    background-color: #0000CC;
  }
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const RemoveButton = styled.button`
  background-color: #f44336;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  
  &:hover {
    background-color: #d32f2f;
  }
`;


const CustomCheckbox = styled.label`
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  user-select: none;
  
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #eee;
    border: 1px solid #ccc;
    border-radius: 2px;
  }
  
  &:hover .checkmark {
    background-color: #ccc;
  }
  
  input:checked ~ .checkmark {
    background-color: #0000FF;
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  input:checked ~ .checkmark:after {
    display: block;
  }
  
  .checkmark:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
`;
const MapContainer = styled.div`
  height: 200px;
  margin-top: 10px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ddd;
`;

const AddressInputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const SuggestionsContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 5px;
`;

const SuggestionItem = styled.div`
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;

const LoadingIndicator = styled.div`
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-top: 5px;
`;

// Helper to safely parse JSON with error handling
const safeParseJSON = (jsonString, defaultValue = []) => {
  if (!jsonString || typeof jsonString !== 'string' || jsonString.trim() === '') {
    return defaultValue;
  }
  
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    console.error(`Error parsing JSON: ${e.message}`, jsonString);
    return defaultValue;
  }
};

// Helper to stringify JSON with error handling
const safeStringifyJSON = (jsonObj, defaultValue = "[]") => {
  if (!jsonObj) {
    return defaultValue;
  }
  
  try {
    return JSON.stringify(jsonObj);
  } catch (e) {
    console.error(`Error stringifying JSON: ${e.message}`, jsonObj);
    return defaultValue;
  }
};

const ProjectDetailView = ({ project, candidature, fullUser, onBack, onUpdate, isNewProject = false }) => {
  const { i18n } = useTranslation('common');
  // Always start in edit mode for new projects
  const [editMode, setEditMode] = useState(isNewProject);
  const [projectData, setProjectData] = useState(isNewProject ? createEmptyProject() : project);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [newMedias, setNewMedias] = useState([]);
  const [mediasToDelete, setMediasToDelete] = useState([]);
  
  // States for complex fields
  const [awards, setAwards] = useState([]);
  const [pressLinks, setPressLinks] = useState([]);
  const [fabricants, setFabricants] = useState([]);
  
  // States for tracking which item is currently being edited
  const [editingAwardIndex, setEditingAwardIndex] = useState(null);
  const [editingPressLinkIndex, setEditingPressLinkIndex] = useState(null);
  const [editingFabricantIndex, setEditingFabricantIndex] = useState(null);

  // Add these new Mapbox related states and refs
  const [suggestions, setSuggestions] = useState([]);
  const [isLoadingSuggestions, setIsLoadingSuggestions] = useState(false);
  const timeoutRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const mapContainerRef = useRef(null);
  
  // Initialize Mapbox access token
  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1IjoiZGdjb2Jvc3MiLCJhIjoiY2xzY2JnajIzMGZsNzJpcGM4b3l5OWttaCJ9.1GzkF8EERgQ5u1jkmP3C7w';
  }, []);

  useEffect(() => {
    // Always clean up the previous map instance first to avoid conflicts
    if (mapRef.current) {
      mapRef.current.remove();
      mapRef.current = null;
      markerRef.current = null;
    }
  
    // Only proceed if we have the map container and valid coordinates
    if (!mapContainerRef.current) return;
  
    let lat, lng;
    
    if (editMode) {
      // In edit mode, use formData coordinates
      lat = parseFloat(formData.latitude);
      lng = parseFloat(formData.longitude);
    } else {
      // In view mode, use projectData coordinates
      lat = parseFloat(projectData.latitude);
      lng = parseFloat(projectData.longitude);
    }
  
    // Only create map if we have valid coordinates
    if (isNaN(lat) || isNaN(lng)) return;
  
    // Create map with appropriate settings based on mode
    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [lng, lat],
      zoom: 15,
      interactive: editMode // Only interactive in edit mode
    });
  
    // Create marker appropriate for the mode
    if (editMode) {
      // Draggable marker for edit mode
      markerRef.current = new mapboxgl.Marker({ draggable: true })
        .setLngLat([lng, lat])
        .addTo(mapRef.current);
  
      // Update coordinates when marker is dragged in edit mode
      markerRef.current.on('dragend', () => {
        const newPos = markerRef.current.getLngLat();
        setFormData(prev => ({
          ...prev,
          longitude: newPos.lng.toString(),
          latitude: newPos.lat.toString()
        }));
      });
    } else {
      // Static marker for view mode
      new mapboxgl.Marker()
        .setLngLat([lng, lat])
        .addTo(mapRef.current);
    }
  
    // Cleanup function
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
        markerRef.current = null;
      }
    };
  }, [editMode, projectData.latitude, projectData.longitude, formData.latitude, formData.longitude]);
  
  // Clean up the map when component unmounts
  useEffect(() => {
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  // Function to handle address input changes and fetch suggestions
  const handleAddressChange = (e) => {
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      adresse: value
    }));

    // Clear previous timeout
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    // If input is too short, clear suggestions
    if (value.length <= 2) {
      setSuggestions([]);
      return;
    }

    setIsLoadingSuggestions(true);
    
    // Debounce API call
    timeoutRef.current = setTimeout(async () => {
      try {
        const response = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(value)}.json?access_token=${mapboxgl.accessToken}`
        );
        const data = await response.json();
        setSuggestions(data.features);
      } catch (error) {
        console.error('Geocoding error:', error);
      } finally {
        setIsLoadingSuggestions(false);
      }
    }, 300);
  };

  // Function to handle suggestion selection
  const handleSuggestionClick = (suggestion) => {
    const [longitude, latitude] = suggestion.center;
    setFormData(prev => ({
      ...prev,
      adresse: suggestion.place_name,
      longitude: longitude.toString(),
      latitude: latitude.toString()
    }));
    setSuggestions([]);
  };
  
  // Get listings for form selects
  const typologieObjetFD100 = FD100MultiSelectOptions.typologieObjetFD100(i18n.language);
  const typologieAssiseFD100 = FD100MultiSelectOptions.typologieAssiseFD100(i18n.language);
  const typologieTableFD100 = FD100MultiSelectOptions.typologieTableFD100(i18n.language);
  const typologieLuminaireFD100 = FD100MultiSelectOptions.typologieLuminaireFD100(i18n.language);
  const tyoplogieEspaceFD100 = FD100MultiSelectOptions.tyoplogieEspaceFD100(i18n.language);
  
  // Function to create an empty project object for new projects
  function createEmptyProject() {
    return {
      id_in_participation: `new_${Math.random().toString(36).substring(2, 15)}`,
      name: '',
      aboutfr: '',
      abouten: '',
      public: true,
      autorisation: true,
      type: '',
      typologie: '',
      year: new Date().getFullYear().toString(),
      medias: [],
      fabrication_fr: '',
    };
  }
  
  // Function to force refresh project data after updates
  const forceRefreshMediaData = async () => {
    setLoading(true);
    
    try {
      // Fetch fresh participation data
      console.log("Fetching fresh participation data...");
      const refreshedParticipations = await api.getUserParticipations({ userid: fullUser.user._id });
      
      if (refreshedParticipations && refreshedParticipations.data) {
        console.log("Got participations:", refreshedParticipations.data.length);
        const refreshedParticipation = refreshedParticipations.data.find(p => p._id === candidature._id);
        
        if (refreshedParticipation) {
          console.log("Found matching participation:", refreshedParticipation._id);
          
          // Find the updated project in the refreshed data
          let refreshedProject = null;
          
          // Handle both object and string IDs in projects array
          if (refreshedParticipation.data && refreshedParticipation.data.projets) {
            console.log("Participation has projects:", refreshedParticipation.data.projets.length);
            
            // First check for projects that are objects
            for (const proj of refreshedParticipation.data.projets) {
              if (typeof proj === 'object' && proj.id_in_participation === projectData.id_in_participation) {
                refreshedProject = proj;
                console.log("Found project as object in participation");
                break;
              }
            }
            
            // If not found as object, check if it's a string ID
            if (!refreshedProject) {
              console.log("Checking if project is stored as string ID...");
              // Get company projects to match against
              const companyProjects = fullUser.company.projects || [];
              
              for (const projId of refreshedParticipation.data.projets) {
                if (typeof projId === 'string') {
                  const companyProject = companyProjects.find(p => p._id === projId);
                  if (companyProject && companyProject._id === projectData.id_in_company) {
                    refreshedProject = companyProject;
                    console.log("Found project as ID in participation");
                    break;
                  }
                }
              }
            }
          }
          
          if (refreshedProject) {
            console.log("Setting refreshed project data:", refreshedProject);
            setProjectData(refreshedProject);
            return true;
          } else {
            console.log("Project not found in refreshed data");
          }
        } else {
          console.log("Participation not found in refreshed data");
        }
      }
      return false;
    } catch (error) {
      console.error("Error refreshing data:", error);
      return false;
    } finally {
      setLoading(false);
    }
  };
  
  // Determine minimum required media count based on project type
  const getMinimumMediaCount = () => {
    return formData.type === 'objet' ? 5 : 8;
  };
  
  useEffect(() => {
    if (isNewProject) {
      // Initialize with empty data for new projects
      const emptyProject = createEmptyProject();
      setProjectData(emptyProject);
      setFormData({
        name: '',
        aboutfr: '',
        abouten: '',
        public: true,
        autorisation: true,
        type: '',
        typologie: '',
        typologieAssise: '',
        typologieTable: '',
        typologieLuminaire: '',
        autre_typologie: '',
        year: new Date().getFullYear().toString(),
        adresse: '',
        latitude: '',
        longitude: '',
        fabrication_fr: '',
        communiquer_fabricants: '',
        editeur: '',
        distributeur: '',
        pays_distribution: '',
        echelle_production: '',
        unique_collection: ''
      });
    } else if (project) {

      //if project.id_in_participation is not set, set it to a random string
      if (!project.id_in_participation) {
        project.id_in_participation = Math.random().toString(36).substring(2);
      }

      // Initialize with existing project data
      setProjectData(project);
      setFormData({
        name: project.name || '',
        aboutfr: project.aboutfr || '',
        abouten: project.abouten || '',
        public: project.public !== false,
        autorisation: project.autorisation !== false,
        type: project.type || '',
        typologie: project.typologie || '',
        typologieAssise: project.typologieAssise || '',
        typologieTable: project.typologieTable || '',
        typologieLuminaire: project.typologieLuminaire || '',
        autre_typologie: project.autre_typologie || '',
        year: project.year || '',
        adresse: project.adresse || '',
        latitude: project.latitude || '',
        longitude: project.longitude || '',
        fabrication_fr: project.fabrication_fr || '',
        communiquer_fabricants: project.communiquer_fabricants || '',
        editeur: project.editeur || '',
        distributeur: project.distributeur || '',
        pays_distribution: project.pays_distribution || '',
        echelle_production: project.echelle_production || '',
        unique_collection: project.unique_collection || ''
      });
      
      // Parse JSON fields
      setAwards(safeParseJSON(project.awards, []));
      setPressLinks(safeParseJSON(project.lien_presse, []));
      setFabricants(safeParseJSON(project.fabricants, []));
    }
  }, [project, isNewProject]);
  
  // When type changes, reset the typology if needed
  useEffect(() => {
    if (formData.type === "objet") {
      if (!typologieObjetFD100.find(option => option.value === formData.typologie)) {
        setFormData(prev => ({
          ...prev,
          typologie: typologieObjetFD100[0]?.value || ''
        }));
      }
    } else if (formData.type === "espace") {
      if (!tyoplogieEspaceFD100.find(option => option.value === formData.typologie)) {
        setFormData(prev => ({
          ...prev,
          typologie: tyoplogieEspaceFD100[0]?.value || ''
        }));
      }
    }
  }, [formData.type, typologieObjetFD100, tyoplogieEspaceFD100]);
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    // Handle checkbox inputs
    if (type === 'checkbox') {
      setFormData({
        ...formData,
        [name]: checked
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  
  const handleCancel = () => {
    if (isNewProject) {
      // For new projects, go back to the projects list
      onBack();
    } else {
      // For existing projects, exit edit mode
      setEditMode(false);
      setFormData({
        name: projectData.name || '',
        aboutfr: projectData.aboutfr || '',
        abouten: projectData.abouten || '',
        public: projectData.public !== false,
        autorisation: projectData.autorisation !== false,
        type: projectData.type || '',
        typologie: projectData.typologie || '',
        typologieAssise: projectData.typologieAssise || '',
        typologieTable: projectData.typologieTable || '',
        typologieLuminaire: projectData.typologieLuminaire || '',
        autre_typologie: projectData.autre_typologie || '',
        year: projectData.year || '',
        adresse: projectData.adresse || '',
        latitude: projectData.latitude || '',
        longitude: projectData.longitude || '',
        fabrication_fr: projectData.fabrication_fr || '',
        communiquer_fabricants: projectData.communiquer_fabricants || '',
        editeur: projectData.editeur || '',
        distributeur: projectData.distributeur || '',
        pays_distribution: projectData.pays_distribution || '',
        echelle_production: projectData.echelle_production || '',
        unique_collection: projectData.unique_collection || ''
      });
      
      // Reset JSON fields
      setAwards(safeParseJSON(projectData.awards, []));
      setPressLinks(safeParseJSON(projectData.lien_presse, []));
      setFabricants(safeParseJSON(projectData.fabricants, []));
      
      setNewMedias([]);
      setMediasToDelete([]);
      
      // Reset editing indexes
      setEditingAwardIndex(null);
      setEditingPressLinkIndex(null);
      setEditingFabricantIndex(null);
    }
  };
  
  // Check if fabricants should be added
  const shouldAddFabricants = () => {
    return formData.type === "objet" || (formData.type === "espace" && formData.fabrication_fr === "oui");
  };
  
  const handleSelectChange = (selectedOption, { name }) => {
    setFormData({
      ...formData,
      [name]: selectedOption.value
    });
  };
  
  // Award management - updated functions
  const addAward = () => {
    if (editingAwardIndex === null) {
      const newAward = { title: '', year: '' };
      setAwards([...awards, newAward]);
      setEditingAwardIndex(awards.length);
    }
  };
  
  const removeAward = (index) => {
    const newAwards = [...awards];
    newAwards.splice(index, 1);
    setAwards(newAwards);
    
    // If removing the currently edited item, reset the editing state
    if (editingAwardIndex === index) {
      setEditingAwardIndex(null);
    } else if (editingAwardIndex > index) {
      // Adjust editing index if removing item before the current edit
      setEditingAwardIndex(editingAwardIndex - 1);
    }
  };
  
  const updateAward = (index, field, value) => {
    const newAwards = [...awards];
    newAwards[index][field] = value;
    setAwards(newAwards);
  };
  
  const handleEditAward = (index) => {
    setEditingAwardIndex(index);
  };
  
  const handleFinishEditingAward = (index) => {
    setEditingAwardIndex(null);
  };
  
  // Press links management - updated functions
  const addPressLink = () => {
    if (editingPressLinkIndex === null) {
      const newLink = { title: '', url: '' };
      setPressLinks([...pressLinks, newLink]);
      setEditingPressLinkIndex(pressLinks.length);
    }
  };
  
  const removePressLink = (index) => {
    const newLinks = [...pressLinks];
    newLinks.splice(index, 1);
    setPressLinks(newLinks);
    
    // If removing the currently edited item, reset the editing state
    if (editingPressLinkIndex === index) {
      setEditingPressLinkIndex(null);
    } else if (editingPressLinkIndex > index) {
      // Adjust editing index if removing item before the current edit
      setEditingPressLinkIndex(editingPressLinkIndex - 1);
    }
  };
  
  const updatePressLink = (index, field, value) => {
    const newLinks = [...pressLinks];
    newLinks[index][field] = value;
    setPressLinks(newLinks);
  };
  
  const handleEditPressLink = (index) => {
    setEditingPressLinkIndex(index);
  };
  
  const handleFinishEditingPressLink = (index) => {
    setEditingPressLinkIndex(null);
  };
  
  // Fabricants management - updated functions
  const addFabricant = () => {
    if (editingFabricantIndex === null) {
      const newFabricant = { name: '', work: '', contact: '', email: '' };
      setFabricants([...fabricants, newFabricant]);
      setEditingFabricantIndex(fabricants.length);
    }
  };
  
  const removeFabricant = (index) => {
    const newFabricants = [...fabricants];
    newFabricants.splice(index, 1);
    setFabricants(newFabricants);
    
    // If removing the currently edited item, reset the editing state
    if (editingFabricantIndex === index) {
      setEditingFabricantIndex(null);
    } else if (editingFabricantIndex > index) {
      // Adjust editing index if removing item before the current edit
      setEditingFabricantIndex(editingFabricantIndex - 1);
    }
  };
  
  const updateFabricant = (index, field, value) => {
    const newFabricants = [...fabricants];
    newFabricants[index][field] = value;
    setFabricants(newFabricants);
  };
  
  const handleEditFabricant = (index) => {
    setEditingFabricantIndex(index);
  };
  
  const handleFinishEditingFabricant = (index) => {
    setEditingFabricantIndex(null);
  };
  
  const validateForm = () => {
    // Check that autorisation is checked
    if (!formData.autorisation) {
      alert(i18n.language === "fr" 
        ? "Veuillez certifier avoir l'autorisation de communiquer sur le projet au moment de la révélation du prix" 
        : "Please certify that you have permission to communicate about the project at the time of the prize reveal");
      return false;
    }

    // Check required fields
    if (!formData.name) {
      alert(i18n.language === "fr" ? "Veuillez renseigner le nom du projet" : "Please fill in the project name");
      return false;
    }

    if (!formData.aboutfr) {
      alert(i18n.language === "fr" ? "Veuillez remplir la description du projet en français" : "Please fill in the project description in French");
      return false;
    }

    if (!formData.abouten) {
      alert(i18n.language === "fr" ? "Veuillez remplir la description du projet en anglais" : "Please fill in the project description in English");
      return false;
    }

    if (!formData.year) {
      alert(i18n.language === "fr" ? "Veuillez renseigner l'année du projet" : "Please fill in the project year");
      return false;
    }

    if (!formData.type) {
      alert(i18n.language === "fr" ? "Veuillez renseigner le type de projet" : "Please fill in the project type");
      return false;
    }

    if (!formData.typologie) {
      alert(i18n.language === "fr" ? "Veuillez renseigner la typologie du projet" : "Please fill in the project typology");
      return false;
    }

    // Check required fields for objects
    if (formData.type === "objet") {
      if (!formData.editeur) {
        alert(i18n.language === "fr" ? "Veuillez renseigner l'éditeur" : "Please fill in the editor");
        return false;
      }

      if (!formData.distributeur) {
        alert(i18n.language === "fr" ? "Veuillez renseigner le distributeur" : "Please fill in the distributor");
        return false;
      }

      if (!formData.pays_distribution) {
        alert(i18n.language === "fr" ? "Veuillez renseigner le pays de distribution" : "Please fill in the distribution country");
        return false;
      }

      if (!formData.unique_collection) {
        alert(i18n.language === "fr" ? "Veuillez renseigner s'il s'agit d'une pièce unique ou d'une collection" : "Please fill in whether it is a single piece or a collection");
        return false;
      }

      if (!formData.echelle_production) {
        alert(i18n.language === "fr" ? "Veuillez renseigner l'échelle de production" : "Please fill in the production scale");
        return false;
      }
    }

    // Check required fields for specific typologies
    if (formData.typologie === "assise" && !formData.typologieAssise) {
      alert(i18n.language === "fr" ? "Veuillez rensigner le type d'assise" : "Please fill in the seating type");
      return false;
    }

    if (formData.typologie === "table" && !formData.typologieTable) {
      alert(i18n.language === "fr" ? "Veuillez rensigner le type de table" : "Please fill in the table type");
      return false;
    }

    if (formData.typologie === "luminaire" && !formData.typologieLuminaire) {
      alert(i18n.language === "fr" ? "Veuillez rensigner le type de luminaire" : "Please fill in the luminaire type");
      return false;
    }

    // Check required fields for spaces
    if (formData.type === "espace") {
      if (!formData.adresse) {
        alert(i18n.language === "fr" ? "Veuillez rensigner l'adresse" : "Please fill in the address");
        return false;
      }
      //Pour bloquer les adresse en france decommentez :
      // if (formData.adresse.endsWith(", France")) {
      //   alert(i18n.language === "fr" ? "Les projets situés en France ne sont pas éligibles à l'appel à projet." : "Projects located in France are not eligible for the call for projects");
      //   return false;
      // }
    }

    // Check fabricants if needed
    if (shouldAddFabricants() && fabricants.length === 0) {
      alert(i18n.language === "fr" ? "Veuillez ajouter au moins un fabricant" : "Please add at least one manufacturer");
      return false;
    }

    // Check minimum required media count
    // For new projects, only new media count matters
    const oldMediasCount = isNewProject ? 0 : (projectData.medias?.length || 0) - mediasToDelete.length;
    const totalMediaCount = oldMediasCount + newMedias.length;
    const minimumMediasCount = getMinimumMediaCount();

    if (totalMediaCount < minimumMediasCount) {
      alert(i18n.language === "fr" 
        ? `Veuillez ajouter au moins ${minimumMediasCount} médias` 
        : `Please add at least ${minimumMediasCount} media`);
      return false;
    }

    // Add validation for coordinates if type is 'espace'
    if (formData.type === "espace") {
      if (!formData.adresse) {
        alert(i18n.language === 'fr' ? 'Veuillez renseigner l\'adresse' : 'Please fill in the address');
        return false;
      }

      if (!formData.latitude || !formData.longitude) {
        alert(i18n.language === 'fr' ? 'Veuillez sélectionner une position sur la carte' : 'Please select a position on the map');
        return false;
      }

      // Keep your France validation
      if (formData.adresse.endsWith(", France")) {
        alert(i18n.language === 'fr' ? 'Les projets situés en France ne sont pas éligibles à l\'appel à projet.' : 'Projects located in France are not eligible for the call for projects');
        return false;
      }
    }

    // Check if any item is still being edited
    if (editingAwardIndex !== null || editingPressLinkIndex !== null || editingFabricantIndex !== null) {
      alert(i18n.language === "fr" 
        ? "Veuillez terminer l'édition de tous les éléments avant d'enregistrer" 
        : "Please finish editing all items before saving");
      return false;
    }

    return true;
  };

  const validateMediaFiles = () => {
    // Check if any of the new media objects have empty or invalid file properties
    const invalidMedias = newMedias.filter(
      media => !media.file || !(media.file instanceof File) || !media.file.size
    );
    
    if (invalidMedias.length > 0) {
      console.error("Found invalid media files:", invalidMedias);
      alert(i18n.language === 'fr' 
        ? 'Certains fichiers médias sont invalides. Veuillez les supprimer et réessayer.' 
        : 'Some media files are invalid. Please remove them and try again.');
      return false;
    }
    
    return true;
  };

  const handleSave = async () => {
    try {
      if (!validateForm()) {
        return;
      }
      // Add this new validation
      if (!validateMediaFiles()) {
        return;
      }
      
      setLoading(true);
      
      api.LogFront(`FD1002025 ${isNewProject ? 'creating' : 'updating'} project ${formData.name} with ID: ${projectData.id_in_participation}`);
      
      // Convert JSON objects to strings
      const awardsJSON = safeStringifyJSON(awards);
      const pressLinksJSON = safeStringifyJSON(pressLinks);
      const fabricantsJSON = safeStringifyJSON(fabricants);
      
      // Create updated project object in the EXACT same way as Step2.js
      const updatedProject = {
        ...projectData,
        name: formData.name,
        aboutfr: formData.aboutfr,
        abouten: formData.abouten,
        public: formData.public,
        autorisation: formData.autorisation,
        type: formData.type,
        typologie: formData.typologie,
        typologieAssise: formData.typologieAssise || '',
        typologieTable: formData.typologieTable || '',
        typologieLuminaire: formData.typologieLuminaire || '',
        autre_typologie: formData.autre_typologie || '',
        year: formData.year,
        adresse: formData.adresse || '',
        latitude: formData.latitude || '',
        longitude: formData.longitude || '',
        fabrication_fr: formData.fabrication_fr,
        communiquer_fabricants: formData.communiquer_fabricants || '',
        editeur: formData.editeur || '',
        distributeur: formData.distributeur || '',
        pays_distribution: formData.pays_distribution || '',
        echelle_production: formData.echelle_production || '',
        unique_collection: formData.unique_collection || '',
        awards: awardsJSON,
        lien_presse: pressLinksJSON,
        fabricants: fabricantsJSON,
        // Include exactly the same media handling fields as Step2.js
        medias: projectData.medias || [],
        newMedias: newMedias,
        mediasToDelete: mediasToDelete
      };

      // remove the mediasToDelete from the medias array
      if (projectData.medias) {
        updatedProject.medias = projectData.medias.filter(media => !mediasToDelete.includes(media.path));
      }
      
      console.log("Submitting updated project:", JSON.stringify(updatedProject, null, 2));
      
      // Update projects array in candidature
      let updatedProjects;
      
      if (isNewProject) {
        // Add new project to candidature
        updatedProjects = candidature.data.projets ? [...candidature.data.projets, updatedProject] : [updatedProject];
      } else {
        // Update existing project
        updatedProjects = candidature.data.projets.map(p => 
          p.id_in_participation === projectData.id_in_participation ? updatedProject : p
        );
      }
      
      // Create FormData for submission exactly as Step2.js does
      const submission = new FormData();
      
      submission.append("userId", fullUser.user._id);
      submission.append("eventId", candidature.eventId);
      submission.append("participationId", candidature._id);
      
      // Preserve contact info
      submission.append("culture_francaise", candidature.data.culture_francaise || '');
      submission.append("contact_nom", candidature.data.contact_nom || '');
      submission.append("contact_prenom", candidature.data.contact_prenom || '');
      submission.append("contact_mail", candidature.data.contact_mail || '');
      submission.append("contact_telephone", candidature.data.contact_telephone || '');
      
      // Add projets array (crucial to use the same format as Step2.js)
      submission.append("projets", JSON.stringify(updatedProjects));
      
      // Add files (critical to match Step2.js exactly)
      console.log("Adding files, newMedias count:", newMedias.length);
      for (let i = 0; i < newMedias.length; i++) {
        const media = newMedias[i];
        if (media && media.file && media.file instanceof File) {
          const key = `file_${updatedProject.id_in_participation}_${i}`;
          console.log(`Adding file ${key}: ${media.file.name} (${media.file.size} bytes)`);
          submission.append(key, media.file);
        }
      }
      
      // Make API call
      console.log("Making API call with FormData");
      const response = await api.saveFD1002025(submission);
      
      if (response.data === "success") {
        console.log("Save successful, refreshing data");
        
        // Force a refresh to get the updated media paths
        const refreshSuccess = await forceRefreshMediaData();
        
        if (!refreshSuccess) {
          console.log("Couldn't refresh data automatically, using basic update");
          // Update local state as a fallback
          const updatedMedias = projectData.medias 
            ? projectData.medias.filter(media => !mediasToDelete.includes(media.path)) 
            : [];
          
          const basicUpdatedProject = {
            ...updatedProject,
            medias: updatedMedias,
            newMedias: undefined,
            mediasToDelete: undefined
          };
          
          setProjectData(basicUpdatedProject);
        }
        
        // Reset edit state if editing existing project
        if (!isNewProject) {
          setEditMode(false);
        }
        
        setNewMedias([]);
        setMediasToDelete([]);
        
        // Notify parent component
        if (onUpdate) {
          console.log("Notifying parent component of update");
          onUpdate(updatedProject);
        }
        
        // For new projects, redirect back to the projects list
        if (isNewProject) {
          alert(i18n.language === 'fr' ? 'Projet créé avec succès!' : 'Project created successfully!');
          onBack();
          //refresh the page in 1 second
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          alert(i18n.language === 'fr' ? 'Projet mis à jour avec succès!' : 'Project updated successfully!');
          //refresh the page in 1 second
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      } else {
        throw new Error(response.data || 'Unknown error');
      }
    } catch (error) {
      console.error("Error updating project:", error);
      alert(i18n.language === 'fr' 
        ? 'Erreur lors de la mise à jour. Veuillez réessayer.' 
        : 'Error updating. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Handle adding new media with the dropzone component
  const handleAddMedia = (media) => {
    setNewMedias([...newMedias, media]);
  };
  
  // Handle removing new media
  const handleRemoveNewMedia = (mediaToRemove) => {
    const updatedMedias = newMedias.filter(media => media !== mediaToRemove);
    setNewMedias(updatedMedias);
  };
  
  // Handle deleting existing media
  const handleDeleteMedia = (media) => {
    setMediasToDelete([...mediasToDelete, media.path]);
  };
  
  const renderMediaGallery = () => {
    if (!projectData.medias || projectData.medias.length === 0) {
      return <p>{i18n.language === 'fr' ? 'Aucun média disponible' : 'No media available'}</p>;
    }
    
    return (
      <MediaGallery>
        {projectData.medias
          .filter(media => !mediasToDelete.includes(media.path))
          .map((media, index) => (
            <MediaPreviewItem 
              key={index} 
              media={media} 
              isNew={false} 
              onDelete={editMode ? handleDeleteMedia : null} 
            />
          ))}
      </MediaGallery>
    );
  };
  
  const renderNewMediaPreviews = () => {
    if (newMedias.length === 0) return null;
    
    return (
      <MediaGallery>
        {newMedias.map((media, index) => (
          <MediaPreviewItem 
            key={index} 
            media={media} 
            isNew={true} 
            onDelete={handleRemoveNewMedia} 
          />
        ))}
      </MediaGallery>
    );
  };
  
  const getTypologieOptions = () => {
    if (formData.type === 'objet') {
      return typologieObjetFD100;
    } else if (formData.type === 'espace') {
      return tyoplogieEspaceFD100;
    }
    return [];
  };

  const inscriptionsOpened = (date) => {
        const dateObj = new Date(date);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        return dateObj.getTime() > currentDate.getTime();
    }
  
  return (
    <ProjectDetailContainer>
      <BackButton onClick={onBack}>
        <img src="/img/fleche_blanche.png" alt="" />
        {i18n.language === 'fr' ? 'Retour aux projets' : 'Back to projects'}
      </BackButton>
      
      <ProjectHeader>
        <BigH2>{projectData.name}</BigH2>
        <div style={{ display: 'flex', gap: '10px' }}>
          {!editMode && inscriptionsOpened(candidature.event.inscriptions_end_date) && (
            <>
              <BlueButton onClick={() => setEditMode(true)}>
                <img src="/img/fleche_blanche.png" alt="" />
                {i18n.language === 'fr' ? 'Modifier le projet' : 'Edit project'}
              </BlueButton>
            </>
          )}
        </div>
      </ProjectHeader>
      
      {!editMode ? (
        <>
          <ProjectGrid>
            <ProjectSection>
              <BigH3WithMargin style={{marginBottom:'15px'}}>{i18n.language === 'fr' ? 'Informations générales' : 'General Information'}</BigH3WithMargin>
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Type:' : 'Type:'}</div>
                <div className="value">
                  {projectData.type === 'objet' 
                    ? (i18n.language === 'fr' ? 'Objet' : 'Object')
                    : (i18n.language === 'fr' ? 'Espace' : 'Space')}
                </div>
              </DetailItem>
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Typologie:' : 'Typology:'}</div>
                <div className="value">
                  {getTypologieOptions().find(opt => opt.value === projectData.typologie)?.label || projectData.typologie}
                </div>
              </DetailItem>
              
              {projectData.typologie === 'assise' && (
                <DetailItem>
                  <div className="label">{i18n.language === 'fr' ? 'Type d\'assise:' : 'Seating type:'}</div>
                  <div className="value">
                    {typologieAssiseFD100.find(opt => opt.value === projectData.typologieAssise)?.label || projectData.typologieAssise}
                  </div>
                </DetailItem>
              )}
              
              {projectData.typologie === 'table' && (
                <DetailItem>
                  <div className="label">{i18n.language === 'fr' ? 'Type de table:' : 'Table type:'}</div>
                  <div className="value">
                    {typologieTableFD100.find(opt => opt.value === projectData.typologieTable)?.label || projectData.typologieTable}
                  </div>
                </DetailItem>
              )}
              
              {projectData.typologie === 'luminaire' && (
                <DetailItem>
                  <div className="label">{i18n.language === 'fr' ? 'Type de luminaire:' : 'Lighting type:'}</div>
                  <div className="value">
                    {typologieLuminaireFD100.find(opt => opt.value === projectData.typologieLuminaire)?.label || projectData.typologieLuminaire}
                  </div>
                </DetailItem>
              )}
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Année:' : 'Year:'}</div>
                <div className="value">{projectData.year}</div>
              </DetailItem>
              
              {projectData.type === 'espace' && (
                <DetailItem>
                  <div className="label">{i18n.language === 'fr' ? 'Adresse:' : 'Address:'}</div>
                  <div className="value">{projectData.adresse}</div>
                  
                  {projectData.latitude && projectData.longitude && (
                    <>
                      <div style={{ display: 'flex', gap: '10px', marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ flex: 1 }}>
                          <div className="label">{i18n.language === 'fr' ? 'Coordonnées:' : 'Coordinates:'}</div>
                          <div className="value">
                            {projectData.latitude}, {projectData.longitude}
                          </div>
                        </div>
                      </div>
                      <MapContainer ref={mapContainerRef} />
                    </>
                  )}
                </DetailItem>
              )}
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Fabrication française:' : 'French manufacturing:'}</div>
                <div className="value">
                  {projectData.fabrication_fr === 'oui' 
                    ? (i18n.language === 'fr' ? 'Oui' : 'Yes')
                    : (i18n.language === 'fr' ? 'Non' : 'No')}
                </div>
              </DetailItem>
            </ProjectSection>
            
            <ProjectSection>
              <BigH3WithMargin>{i18n.language === 'fr' ? 'Description' : 'Description'}</BigH3WithMargin>
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Description (FR):' : 'Description (FR):'}</div>
                <div className="value">{projectData.aboutfr}</div>
              </DetailItem>
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Description (EN):' : 'Description (EN):'}</div>
                <div className="value">{projectData.abouten}</div>
              </DetailItem>
            </ProjectSection>
          </ProjectGrid>
          
          {projectData.type === 'objet' && (
            <ProjectSection>
              <BigH3WithMargin>{i18n.language === 'fr' ? 'Informations commerciales' : 'Commercial Information'}</BigH3WithMargin>
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Pièce unique ou collection:' : 'Single piece or collection:'}</div>
                <div className="value">
                  {projectData.unique_collection === 'unique' 
                    ? (i18n.language === 'fr' ? 'Pièce unique' : 'Single piece')
                    : (i18n.language === 'fr' ? 'Collection' : 'Collection')}
                </div>
              </DetailItem>
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Échelle de production:' : 'Production scale:'}</div>
                <div className="value">
                  {projectData.echelle_production === 'industrielle' 
                    ? (i18n.language === 'fr' ? 'Industrielle' : 'Industrial')
                    : projectData.echelle_production === 'edition_limitee'
                      ? (i18n.language === 'fr' ? 'Édition limitée' : 'Limited edition')
                      : (i18n.language === 'fr' ? 'Pièce unique' : 'Single piece')}
                </div>
              </DetailItem>
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Éditeur:' : 'Publisher:'}</div>
                <div className="value">{projectData.editeur}</div>
              </DetailItem>
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Distributeur:' : 'Distributor:'}</div>
                <div className="value">{projectData.distributeur}</div>
              </DetailItem>
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Pays de distribution:' : 'Distribution country:'}</div>
                <div className="value">
                  {projectData.pays_distribution === 'europe' 
                    ? 'Europe'
                    : (i18n.language === 'fr' ? 'Grand Export' : 'Grand Export')}
                </div>
              </DetailItem>
            </ProjectSection>
          )}
          
          <ProjectSection>
            <BigH3WithMargin>{i18n.language === 'fr' ? 'Médias' : 'Media'}</BigH3WithMargin>
            {renderMediaGallery()}
          </ProjectSection>
          
          {projectData.awards && projectData.awards !== "" && (
            <ProjectSection>
              <BigH3WithMargin>{i18n.language === 'fr' ? 'Récompenses' : 'Awards'}</BigH3WithMargin>
              <ul>
                {(() => {
                  const parsedAwards = safeParseJSON(projectData.awards);
                  if (Array.isArray(parsedAwards) && parsedAwards.length > 0) {
                    return parsedAwards.map((award, index) => (
                      <li key={index}>{award.title} ({award.year})</li>
                    ));
                  }
                  return <li>{projectData.awards}</li>;
                })()}
              </ul>
            </ProjectSection>
          )}
          
          {projectData.lien_presse && projectData.lien_presse !== "[]" && (
            <ProjectSection>
              <BigH3WithMargin>{i18n.language === 'fr' ? 'Liens presse' : 'Press links'}</BigH3WithMargin>
              <ul>
                {(() => {
                  const parsedLinks = safeParseJSON(projectData.lien_presse);
                  if (Array.isArray(parsedLinks) && parsedLinks.length > 0) {
                    return parsedLinks.map((link, index) => (
                      <li key={index}>
                        <a href={linkify(link.url)} target="_blank" rel="noopener noreferrer">{link.title}</a>
                      </li>
                    ));
                  }
                  return <li>{projectData.lien_presse}</li>;
                })()}
              </ul>
            </ProjectSection>
          )}
          
          {projectData.fabrication_fr === 'oui' && projectData.fabricants && projectData.fabricants !== "" && (
            <ProjectSection>
              <BigH3WithMargin>{i18n.language === 'fr' ? 'Fabricants' : 'Manufacturers'}</BigH3WithMargin>
              <ul>
                {(() => {
                  const parsedFabricants = safeParseJSON(projectData.fabricants);
                  if (Array.isArray(parsedFabricants) && parsedFabricants.length > 0) {
                    return parsedFabricants.map((fabricant, index) => (
                      <li key={index}>
                        <strong>{fabricant.name}</strong> {fabricant.work ? `- ${fabricant.work}` : ''}
                        <br />
                        {fabricant.contact && <span>{i18n.language === 'fr' ? 'Contact: ' : 'Contact: '}{fabricant.contact}</span>}
                        {fabricant.email && <span> | Email: {fabricant.email}</span>}
                      </li>
                    ));
                  }
                  return <li>{projectData.fabricants}</li>;
                })()}
              </ul>
            </ProjectSection>
          )}
        </>
      ) : (
        <EditModeContainer>
          <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
            <BigH3WithMargin>{i18n.language === 'fr' ? 'Informations générales' : 'General Information'}</BigH3WithMargin>
            
            <DetailItem>
              <div className="label">{i18n.language === 'fr' ? 'Nom du projet:' : 'Project name:'}</div>
              <Input 
                name="name" 
                value={formData.name || ''} 
                onChange={handleChange} 
                style={{width: "100%"}}
                required
              />
            </DetailItem>
            
            <div className="form-grid">
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Type:' : 'Type:'}</div>
                <Select 
                  name="type" 
                  value={formData.type || ''} 
                  onChange={handleChange}
                  style={{width: "100%"}}
                  required
                >
                  <option value="">{i18n.language === 'fr' ? 'Sélectionnez un type' : 'Select a type'}</option>
                  <option value="objet">{i18n.language === 'fr' ? 'Objet' : 'Object'}</option>
                  <option value="espace">{i18n.language === 'fr' ? 'Espace' : 'Space'}</option>
                </Select>
              </DetailItem>
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Typologie:' : 'Typology:'}</div>
                <Select 
                  name="typologie" 
                  value={formData.typologie || ''} 
                  onChange={handleChange}
                  style={{width: "100%"}}
                  required
                >
                  <option value="">{i18n.language === 'fr' ? 'Sélectionnez une typologie' : 'Select a typology'}</option>
                  {getTypologieOptions().map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </Select>
              </DetailItem>
              
              {/* Additional typology fields based on selection */}
              {formData.typologie === 'assise' && (
                <DetailItem>
                  <div className="label">{i18n.language === 'fr' ? 'Type d\'assise:' : 'Seating type:'}</div>
                  <Select 
                    name="typologieAssise" 
                    value={formData.typologieAssise || ''} 
                    onChange={handleChange}
                    style={{width: "100%"}}
                    required
                  >
                    <option value="">{i18n.language === 'fr' ? 'Sélectionnez un type d\'assise' : 'Select a seating type'}</option>
                    {typologieAssiseFD100.map((option) => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </Select>
                </DetailItem>
              )}
              
              {formData.typologie === 'table' && (
                <DetailItem>
                  <div className="label">{i18n.language === 'fr' ? 'Type de table:' : 'Table type:'}</div>
                  <Select 
                    name="typologieTable" 
                    value={formData.typologieTable || ''} 
                    onChange={handleChange}
                    style={{width: "100%"}}
                    required
                  >
                    <option value="">{i18n.language === 'fr' ? 'Sélectionnez un type de table' : 'Select a table type'}</option>
                    {typologieTableFD100.map((option) => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </Select>
                </DetailItem>
              )}
              
              {formData.typologie === 'luminaire' && (
                <DetailItem>
                  <div className="label">{i18n.language === 'fr' ? 'Type de luminaire:' : 'Lighting type:'}</div>
                  <Select 
                    name="typologieLuminaire" 
                    value={formData.typologieLuminaire || ''} 
                    onChange={handleChange}
                    style={{width: "100%"}}
                    required
                  >
                    <option value="">{i18n.language === 'fr' ? 'Sélectionnez un type de luminaire' : 'Select a lighting type'}</option>
                    {typologieLuminaireFD100.map((option) => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </Select>
                </DetailItem>
              )}
              
              {formData.typologie === 'autre' && (
                <DetailItem>
                  <div className="label">{i18n.language === 'fr' ? 'Précisez la typologie:' : 'Specify typology:'}</div>
                  <Input 
                    name="autre_typologie" 
                    value={formData.autre_typologie || ''} 
                    onChange={handleChange} 
                    style={{width: "100%"}}
                    required
                  />
                </DetailItem>
              )}
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Année:' : 'Year:'}</div>
                <Select 
                  name="year" 
                  value={formData.year || ''} 
                  onChange={handleChange}
                  style={{width: "100%"}}
                  required
                >
                  <option value="">{i18n.language === 'fr' ? 'Sélectionnez une année' : 'Select a year'}</option>
                  {Array.from({ length: 13 }, (_, i) => 2024 + i).map(year => (
                    <option key={year} value={year.toString()}>{year}</option>
                  ))}
                </Select>
              </DetailItem>
              
              {formData.type === 'espace' && (
                <DetailItem>
                  <div className="label">{i18n.language === 'fr' ? 'Adresse:' : 'Address:'}</div>
                  <AddressInputContainer>
                    <Textarea 
                      name="adresse" 
                      value={formData.adresse || ''} 
                      onChange={handleAddressChange} 
                      placeholder={i18n.language === 'fr' ? 'Commencez à saisir une adresse...' : 'Start typing an address...'}
                      style={{width: "100%", minHeight: "80px"}}
                      required
                    />
                    {isLoadingSuggestions && (
                      <LoadingIndicator>
                        {i18n.language === 'fr' ? 'Chargement des suggestions...' : 'Loading suggestions...'}
                      </LoadingIndicator>
                    )}
                    {suggestions.length > 0 && (
                      <SuggestionsContainer>
                        {suggestions.map((suggestion) => (
                          <SuggestionItem
                            key={suggestion.id}
                            onClick={() => handleSuggestionClick(suggestion)}
                          >
                            {suggestion.place_name}
                          </SuggestionItem>
                        ))}
                      </SuggestionsContainer>
                    )}
                  </AddressInputContainer>
                  
                  {/* Map display */}
                  {formData.longitude && formData.latitude && (
                    <>
                      <MapContainer ref={mapContainerRef} />
                      {/* Latitude and Longitude inputs */}
                      <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                        <div style={{ flex: 1 }}>
                          <div className="label">{i18n.language === 'fr' ? 'Longitude:' : 'Longitude:'}</div>
                          <Input 
                            name="longitude" 
                            value={formData.longitude || ''} 
                            onChange={handleChange} 
                            style={{width: "100%"}}
                            readOnly 
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <div className="label">{i18n.language === 'fr' ? 'Latitude:' : 'Latitude:'}</div>
                          <Input 
                            name="latitude" 
                            value={formData.latitude || ''} 
                            onChange={handleChange} 
                            style={{width: "100%"}}
                            readOnly
                          />
                        </div>
                      </div>
                    </>
                  )}
                  
                  <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>
                    {i18n.language === 'fr' 
                      ? 'Les projets situés en France ne sont pas éligibles.' 
                      : 'Projects located in France are not eligible.'}
                  </div>
                </DetailItem>
              )}
              
              <DetailItem>
                <div className="label">{i18n.language === 'fr' ? 'Fabrication française:' : 'French manufacturing:'}</div>
                <Select 
                  name="fabrication_fr" 
                  value={formData.fabrication_fr || ''} 
                  onChange={handleChange}
                  style={{width: "100%"}}
                  required
                >
                  <option value="">{i18n.language === 'fr' ? 'Sélectionnez une option' : 'Select an option'}</option>
                  <option value="oui">{i18n.language === 'fr' ? 'Oui' : 'Yes'}</option>
                  <option value="non">{i18n.language === 'fr' ? 'Non' : 'No'}</option>
                </Select>
              </DetailItem>
            </div>
            
            <BigH3WithMargin>{i18n.language === 'fr' ? 'Description' : 'Description'}</BigH3WithMargin>
            
            <DetailItem>
              <div className="label">{i18n.language === 'fr' ? 'Description (FR):' : 'Description (FR):'}</div>
              <Textarea 
                name="aboutfr" 
                value={formData.aboutfr || ''} 
                onChange={handleChange} 
                style={{width: "100%", minHeight: "150px"}}
                required
              />
            </DetailItem>
            
            <DetailItem>
              <div className="label">{i18n.language === 'fr' ? 'Description (EN):' : 'Description (EN):'}</div>
              <Textarea 
                name="abouten" 
                value={formData.abouten || ''} 
                onChange={handleChange} 
                style={{width: "100%", minHeight: "150px"}}
                required
              />
            </DetailItem>
            
            {/* Commercial Information for objects */}
            {formData.type === 'objet' && (
              <>
                <BigH3WithMargin>{i18n.language === 'fr' ? 'Informations commerciales' : 'Commercial Information'}</BigH3WithMargin>
                
                <div className="form-grid">
                  <DetailItem>
                    <div className="label">{i18n.language === 'fr' ? 'Pièce unique ou collection:' : 'Single piece or collection:'}</div>
                    <Select 
                      name="unique_collection" 
                      value={formData.unique_collection || ''} 
                      onChange={handleChange}
                      style={{width: "100%"}}
                      required
                    >
                      <option value="">{i18n.language === 'fr' ? 'Sélectionnez une option' : 'Select an option'}</option>
                      <option value="unique">{i18n.language === 'fr' ? 'Pièce unique' : 'Single piece'}</option>
                      <option value="collection">{i18n.language === 'fr' ? 'Collection' : 'Collection'}</option>
                    </Select>
                  </DetailItem>
                  
                  <DetailItem>
                    <div className="label">{i18n.language === 'fr' ? 'Échelle de production:' : 'Production scale:'}</div>
                    <Select 
                      name="echelle_production" 
                      value={formData.echelle_production || ''} 
                      onChange={handleChange}
                      style={{width: "100%"}}
                      required
                    >
                      <option value="">{i18n.language === 'fr' ? 'Sélectionnez une option' : 'Select an option'}</option>
                      <option value="industrielle">{i18n.language === 'fr' ? 'Industrielle' : 'Industrial'}</option>
                      <option value="edition_limitee">{i18n.language === 'fr' ? 'Édition limitée' : 'Limited edition'}</option>
                      <option value="piece_unique">{i18n.language === 'fr' ? 'Pièce unique' : 'Single piece'}</option>
                    </Select>
                  </DetailItem>
                  
                  <DetailItem>
                    <div className="label">{i18n.language === 'fr' ? 'Éditeur:' : 'Publisher:'}</div>
                    <Input 
                      name="editeur" 
                      value={formData.editeur || ''} 
                      onChange={handleChange} 
                      style={{width: "100%"}}
                      required
                    />
                  </DetailItem>
                  
                  <DetailItem>
                    <div className="label">{i18n.language === 'fr' ? 'Distributeur:' : 'Distributor:'}</div>
                    <Input 
                      name="distributeur" 
                      value={formData.distributeur || ''} 
                      onChange={handleChange} 
                      style={{width: "100%"}}
                      required
                    />
                  </DetailItem>
                  
                  <DetailItem>
                    <div className="label">{i18n.language === 'fr' ? 'Pays de distribution:' : 'Distribution country:'}</div>
                    <Select 
                      name="pays_distribution" 
                      value={formData.pays_distribution || ''} 
                      onChange={handleChange}
                      style={{width: "100%"}}
                      required
                    >
                      <option value="">{i18n.language === 'fr' ? 'Sélectionnez une option' : 'Select an option'}</option>
                      <option value="europe">Europe</option>
                      <option value="grand_export">{i18n.language === 'fr' ? 'Grand Export' : 'Grand Export'}</option>
                    </Select>
                  </DetailItem>
                </div>
              </>
            )}
            
            {/* Awards section - UPDATED */}
            <BigH3WithMargin>{i18n.language === 'fr' ? 'Récompenses' : 'Awards'}</BigH3WithMargin>
            {awards.map((award, index) => (
              <AwardItemComponent
                key={index}
                item={award}
                index={index}
                isEditing={editingAwardIndex === index}
                isNew={!award.title && !award.year}
                onEdit={handleEditAward}
                onRemove={removeAward}
                onFinishEditing={handleFinishEditingAward}
                onChange={updateAward}
              />
            ))}
            <AddButton 
              onClick={addAward} 
              type='button'
              disabled={editingAwardIndex !== null}
            >
              {i18n.language === 'fr' ? 'Ajouter une récompense' : 'Add award'}
            </AddButton>
            {editingAwardIndex !== null && (
              <div className="note">
                {i18n.language === 'fr' 
                  ? 'Ajoutez ou annulez la récompense en cours d\'édition avant d\'en ajouter une nouvelle.' 
                  : 'Add or cancel the award being edited before adding a new one.'}
              </div>
            )}
            
            {/* Press links section - UPDATED */}
            <BigH3WithMargin style={{marginTop: '20px'}}>{i18n.language === 'fr' ? 'Liens presse' : 'Press links'}</BigH3WithMargin>
            {pressLinks.map((link, index) => (
              <PressLinkItemComponent
                key={index}
                item={link}
                index={index}
                isEditing={editingPressLinkIndex === index}
                isNew={!link.title && !link.url}
                onEdit={handleEditPressLink}
                onRemove={removePressLink}
                onFinishEditing={handleFinishEditingPressLink}
                onChange={updatePressLink}
              />
            ))}
            <AddButton 
              onClick={addPressLink} 
              type='button'
              disabled={editingPressLinkIndex !== null}
            >
              {i18n.language === 'fr' ? 'Ajouter un lien' : 'Add link'}
            </AddButton>
            {editingPressLinkIndex !== null && (
              <div className="note">
                {i18n.language === 'fr' 
                  ? 'Ajoutez ou annulez le lien en cours d\'édition avant d\'en ajouter un nouveau.' 
                  : 'Add or cancel the link being edited before adding a new one.'}
              </div>
            )}
            
            {/* Manufacturers section - UPDATED */}
            {shouldAddFabricants() && (
              <>
                <BigH3WithMargin style={{marginTop: '20px'}}>{i18n.language === 'fr' ? 'Fabricants' : 'Manufacturers'}</BigH3WithMargin>
                {fabricants.map((fabricant, index) => (
                  <FabricantItemComponent
                    key={index}
                    item={fabricant}
                    index={index}
                    isEditing={editingFabricantIndex === index}
                    isNew={!fabricant.name}
                    onEdit={handleEditFabricant}
                    onRemove={removeFabricant}
                    onFinishEditing={handleFinishEditingFabricant}
                    onChange={updateFabricant}
                  />
                ))}
                <AddButton 
                  onClick={addFabricant} 
                  type='button'
                  disabled={editingFabricantIndex !== null}
                >
                  {i18n.language === 'fr' ? 'Ajouter un fabricant' : 'Add manufacturer'}
                </AddButton>
                {editingFabricantIndex !== null && (
                  <div className="note">
                    {i18n.language === 'fr' 
                      ? 'Ajoutez ou annulez le fabricant en cours d\'édition avant d\'en ajouter un nouveau.' 
                      : 'Add or cancel the manufacturer being edited before adding a new one.'}
                  </div>
                )}
                {fabricants.length === 0 && (
                  <div style={{color: 'red', marginTop: '10px'}}>
                    {i18n.language === 'fr' ? 'Vous devez ajouter au moins un fabricant.' : 'You must add at least one manufacturer.'}
                  </div>
                )}
              </>
            )}
            
            {/* Communication permissions for French manufacturers */}
            {formData.fabrication_fr === 'oui' && (
              <DetailItem style={{marginTop: '20px'}}>
                <div className="label">
                  {i18n.language === 'fr' 
                    ? 'Autorisez-vous Le FRENCH DESIGN à communiquer sur les fabricants qui ont travaillé sur votre projet?' 
                    : 'Do you authorize Le FRENCH DESIGN to communicate about the manufacturers who worked on your project?'}
                </div>
                <Select 
                  name="communiquer_fabricants" 
                  value={formData.communiquer_fabricants || ''} 
                  onChange={handleChange}
                  style={{width: "100%"}}
                >
                  <option value="">{i18n.language === 'fr' ? 'Sélectionnez une option' : 'Select an option'}</option>
                  <option value="oui">{i18n.language === 'fr' ? 'Oui' : 'Yes'}</option>
                  <option value="non">{i18n.language === 'fr' ? 'Non' : 'No'}</option>
                </Select>
              </DetailItem>
            )}
            
            {/* Media upload section */}
            <BigH3WithMargin style={{marginTop: '20px'}}>{i18n.language === 'fr' ? 'Médias' : 'Media'}</BigH3WithMargin>
            
            {/* Current media count information */}
            <div style={{marginBottom: '20px'}}>
              {i18n.language === 'fr' 
                ? `Vous devez avoir au moins ${getMinimumMediaCount()} médias pour ce projet.` 
                : `You must have at least ${getMinimumMediaCount()} media for this project.`}
              <br />
              {i18n.language === 'fr'
                ? `Nombre actuel: ${(projectData.medias?.length || 0) - mediasToDelete.length + newMedias.length}`
                : `Current count: ${(projectData.medias?.length || 0) - mediasToDelete.length + newMedias.length}`}
            </div>
            
            {/* Existing media */}
            <div style={{ marginBottom: '20px' }}>
              <h4>{i18n.language === 'fr' ? 'Médias existants:' : 'Existing media:'}</h4>
              {renderMediaGallery()}
            </div>
            
            {/* New media previews */}
            {newMedias.length > 0 && (
              <div style={{ marginBottom: '20px' }}>
                <h4>{i18n.language === 'fr' ? 'Nouveaux médias:' : 'New media:'}</h4>
                {renderNewMediaPreviews()}
              </div>
            )}
            
            {/* Media upload dropzone */}
            <div>
              <h4>{i18n.language === 'fr' ? 'Ajouter de nouveaux médias:' : 'Add new media:'}</h4>
              <MediaUploadWithDropzone onAddMedia={handleAddMedia} maxSizeMB={50} />
            </div>
            
            {/* Public/Private and Authorization Checkboxes */}
            <CheckboxContainer>
              <span>
                {i18n.language === 'fr' 
                  ? "J'autorise Le FRENCH DESIGN by VIA à rendre public ce projet dans mon portfolio auprès des différents membres de la communauté:" 
                  : "I authorize Le FRENCH DESIGN by VIA to make this project public in my portfolio to the various members of the community:"}
              </span>
              <CustomCheckbox>
                <input 
                  type="checkbox" 
                  name="public" 
                  checked={formData.public} 
                  onChange={handleChange} 
                />
                <span className="checkmark"></span>
              </CustomCheckbox>
            </CheckboxContainer>

            <CheckboxContainer>
              <span>
                {i18n.language === 'fr' 
                  ? "Je certifie avoir l'autorisation de communiquer sur le projet au moment de la révélation du prix soit à partir de décembre 2025:" 
                  : "I certify that I have permission to communicate about the project at the time of the prize announcement, starting from December 2025:"}
              </span>
              <CustomCheckbox>
                <input 
                  type="checkbox" 
                  name="autorisation" 
                  checked={formData.autorisation} 
                  onChange={handleChange} 
                  required
                />
                <span className="checkmark"></span>
              </CustomCheckbox>
            </CheckboxContainer>
            
            <div className="button-container">
              <CancelButton type="button" onClick={handleCancel}>
                {i18n.language === 'fr' ? 'Annuler' : 'Cancel'}
              </CancelButton>
              <SaveButton type="submit" disabled={loading}>
                {loading 
                  ? (i18n.language === 'fr' ? 'Sauvegarde en cours...' : 'Saving...')
                  : (i18n.language === 'fr' ? 'Enregistrer' : 'Save')}
              </SaveButton>
            </div>
          </form>
        </EditModeContainer>
      )}
    </ProjectDetailContainer>
  );
};

export default ProjectDetailView;